(() => {
  const TARGET_SELECTOR = '[class*="_pdp_info_block"][class*="ss_product_vidoes"]';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const players = new Set();
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const productRequests = new Map();

  const getProduct = (url) => {
    if (!productRequests.has(url)) {
      productRequests.set(
        url,
        fetch(`${url}.js`, { headers: { Accept: 'application/json' } })
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)
      );
    }
    return productRequests.get(url);
  };

  const resolveSource = async (video) => {
    const fallback = video.dataset.src;
    const target = parseInt(video.dataset.mobileHeight, 10) || 1080;
    if (!mobileQuery.matches || target >= 1080 || !video.dataset.productUrl) return fallback;
    const product = await getProduct(video.dataset.productUrl);
    const media = product && (product.media || []).find((item) => String(item.id) === video.dataset.mediaId);
    const sources = media
      ? (media.sources || [])
          .filter((source) => source.format === 'mp4' && source.height >= target)
          .sort((first, second) => first.height - second.height)
      : [];
    return sources.length ? sources[0].url : fallback;
  };

  const getTarget = () => document.querySelector(TARGET_SELECTOR);

  const syncAll = () => players.forEach((sync) => sync());

  const initVideo = (wrapper) => {
    if (wrapper.dataset.pdpVideoReady === 'true') return;
    const video = wrapper.querySelector('video');
    if (!video) return;
    wrapper.dataset.pdpVideoReady = 'true';

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    let visible = false;
    let sourceReady = false;

    const sync = () => {
      video.controls = reduceMotion.matches;
      if (!sourceReady) return;
      if (visible && !reduceMotion.matches && !document.hidden) {
        const playing = video.play();
        if (playing && typeof playing.catch === 'function') playing.catch(() => {});
      } else if (!reduceMotion.matches) {
        video.pause();
      }
    };

    players.add(sync);

    resolveSource(video).then((src) => {
      if (src) {
        video.preload = 'metadata';
        video.src = src;
      }
      sourceReady = true;
      sync();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        ([entry]) => {
          visible = entry.isIntersecting && entry.intersectionRatio >= 0.6;
          sync();
        },
        { threshold: [0, 0.6, 1] }
      ).observe(video);
    } else {
      visible = true;
      sync();
    }
  };

  let targetObserver = null;

  const watchForTarget = () => {
    if (targetObserver || !('MutationObserver' in window)) return;
    targetObserver = new MutationObserver(() => {
      if (!getTarget()) return;
      targetObserver.disconnect();
      targetObserver = null;
      initMoreButtons(document);
    });
    targetObserver.observe(document.body, { childList: true, subtree: true });
  };

  const initMoreButtons = (scope) => {
    const buttons = scope.querySelectorAll('[data-pdp-video-more]');
    if (!buttons.length) return;
    const hasTarget = Boolean(getTarget());
    if (!hasTarget) watchForTarget();
    buttons.forEach((button) => {
      button.hidden = !hasTarget;
      if (button.dataset.pdpMoreReady === 'true') return;
      button.dataset.pdpMoreReady = 'true';
      button.addEventListener('click', () => {
        const target = getTarget();
        if (!target) return;
        const top = target.getBoundingClientRect().top + window.scrollY - 16;
        window.scrollTo({ top, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      });
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-pdp-gallery-video]').forEach(initVideo);
    initMoreButtons(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest('media-gallery [data-target], media-gallery .slider-button')) return;
    setTimeout(syncAll, 400);
  });

  document.addEventListener('visibilitychange', syncAll);

  if (typeof reduceMotion.addEventListener === 'function') {
    reduceMotion.addEventListener('change', syncAll);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
